import DashboardPage from 'pages/Dashboard';
import ConsultaPage from 'pages/Consulta';
import CertificadosPage from 'pages/Certificados';
import ValidacaoPage from 'pages/Validacao';
import VisualizacaoPage from 'pages/Visualizacao';
import AuthCallbackPage from 'pages/AuthCallback';
import LoginRedirectPage from 'pages/LoginRedirect';

export const Paths = {
  DASHBOARD: '/',
  CERTIFICADOS: '/certificados',
  CONSULTA: '/consulta',
  VALIDACAO: '/validar/:codigoConsulta?',
  VISUALIZACAO: '/visualizar/:codigoConsulta?',
  AUTH_CALLBACK: '/auth/callback',
  LOGIN: '/login',
};

export const routes = [
  {
    path: Paths.CONSULTA,
    exact: true,
    component: ConsultaPage,
  },
  {
    path: Paths.DASHBOARD,
    exact: true,
    component: DashboardPage,
  },
  {
    path: Paths.CERTIFICADOS,
    exact: true,
    component: CertificadosPage,
  },
];

export const commonRoutes = [{
  path: Paths.LOGIN,
  exact: true,
  component: LoginRedirectPage,
}, {
  path: Paths.AUTH_CALLBACK,
  exact: true,
  component: AuthCallbackPage,
}, {
  path: Paths.VALIDACAO,
  exact: true,
  component: ValidacaoPage,
}, {
  path: Paths.VISUALIZACAO,
  exact: true,
  component: VisualizacaoPage,
}];

export const PrivateHomeRoute = Paths.DASHBOARD;
